const TYPE_INSTAGRAM = 0;
const TYPE_LINKEDIN = 1;
const TYPE_FACEBOOK = 2;
const TYPE_TWITTER = 3;
const TYPE_WEBSITE = 4;

export { TYPE_INSTAGRAM, TYPE_LINKEDIN, TYPE_FACEBOOK, TYPE_TWITTER, TYPE_WEBSITE };
